const iconButtonFileDownBtn = {
  title: 'Gerar qrcode deste equipamento'
};

export default iconButtonFileDownBtn;
